module.exports = __webpack_public_path__ + "static/media/Illus-PlateEmpty@3x.a7bc84e6.png";